import { render, staticRenderFns } from "./TenancyAgreement.vue?vue&type=template&id=97f91c0e&scoped=true&"
import script from "./TenancyAgreement.vue?vue&type=script&lang=ts&"
export * from "./TenancyAgreement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f91c0e",
  null
  
)

export default component.exports